<template>
  <div id="custom-footer-page" class="custom-footer-page">
    <div  class="custom-footer">
    <div class="copy">
      <b class="currentYear"> ©  {{ currentYear }}  <a :href="goToHomePage" target="_blank" class="a_footer"> {{ getClientName}} </a></b>
    </div>
    <div class="footer-nav">

      <span class="item-footer"> <a :href="goToLegalPage" target="_blank" class="a_footer"> {{ $t('footer.legal') }} </a>  </span>
      <span  v-if="!isFM">|</span>
      <span class="item-footer" v-if="!isFM"> <a :href="goToLicensePage" target="_blank" class="a_footer"> {{ $t('footer.license') }}  </a> </span>
      <span>|</span>
      <span class="item-footer"> <a :href="goToContactPage" target="_blank" class="a_footer"> {{ $t('footer.contact') }}  </a> </span>

    </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'CustomFooter',
    computed: {
      ...mapGetters({
        componentStyle: 'layout/getComponentStyle',
      }),
        getClientName(){
            return this.isFM ?  (process.env.TITLE ? process.env.TITLE.toUpperCase() :"") :'EMPREINTE'
        },
        isFM(){
          return process.env.isFM
        },
      currentYear() {
        return new Date().getFullYear();
      },
      clientName() {
        return process.env.CLIENT_NAME;
      },
        goToHomePage(){
          return this.isFM ?  process.env.HOME_URL :"https://www.empreinte.com/"
        },
        goToLegalPage(){
          return this.isFM ?  process.env.HOME_URL+"/legal" :"https://www.empreinte.com/mentions-legales/"
        },
        goToLicensePage(){
            return "https://www.empreinte.com/mentions-legales/"
        },
        goToContactPage(){
            return this.isFM ?  process.env.HOME_URL+"?type=contact":"https://www.empreinte.com"
        }
    },
  };
</script>

<style lang="scss">

  .darkMode{
    .a_footer , .currentYear{
      color:#ffffff!important; ;
    }
    .a_footer:hover{
      color:#ffffff !important ;
      text-decoration:none!important;
    }
    .custom-footer-page{
      background-color: #2a2a2a;

    }
  }


  .currentYear{
    font-family: Roboto;

  }
  .content {
    background-color: #e8e8e8;

  }
  .a_footer{
    color:#000000 ;
  }
  .a_footer:hover{
    color:#000000 !important ;
    text-decoration:none!important;
  }
  .item-footer{
    cursor: pointer;
    font-family: Roboto;
  }

  .custom-footer-page{
    z-index: 99;
    align-items: center;
    background-color: #e8e8e8;
    position: sticky;
    bottom: 0;
    width: calc(100% + 30px);
    margin-left: -15px;
  }

  @media (min-width: 1600px){


  .custom-footer {
    max-width: 1400px !important;
  }
  }

  @media (min-width: 992px){
  .custom-footer {
    max-width: 1117px;
  }}





  .custom-footer {
    align-items: center;
    justify-content: space-between;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    padding-right: 25px;
    padding-left: 25px;
    margin-right: auto;
    margin-left: auto;
    min-height: 58px;
  }

</style>



// WEBPACK FOOTER //
// src/components/CustomComponents/CustomFooter.vue